export enum Size {
  Sm = "sm",
  Md = "md",
  Lg = "lg",
  Xl = "xl",
  Xxl = "xxl"
}

export enum Color {
  Primary = "primary",
  Secondary = "secondary",
  Red = "red",
  Yellow = "yellow",
  Grey = "grey",
  Purple = "purple",

  // Special colors
  Gyldendal = "gyldendal",
  Blurple = "blurple",
  Gold = "gold"
}

export enum ColorVariant {
  V110 = "110",
  Base = "base",
  V50 = "50",
  V25 = "25",
  V10 = "10"
}

export enum Gradient {
  Blurple = "blurple",
  Gold = "gold"
}

// Using a template string, convert the enum values to a type (for extending)
export type ColorType = `${Color}`;
export type SizeType = `${Size}`;

export enum State {
  None = "",
  Hovered = "hovered",
  Focused = "focused"
}
